//Reducer Actions -
export const SUBMIT_FINAL = 'SUBMIT_FINAL';
// Created for specialization
export const SUBMIT_BUTTON_UPDATE = 'SUBMIT_BUTTON_UPDATE';

// Links
export const RESELLER_GUIDE = 'http://partnerdownload.adobe.com/p/NA_Reseller_Program_Guide_UE.pdf';
export const ADOBE_CHANNEL_PARTNER = 'https://partners.adobe.com/channelpartners/home.html';
export const CONTACT_HELPDESK = 'http://www.adobe.com/support/reseller/';
export const RESELLER_PROG_TANDC = 'http://partnerdownload.adobe.com/p/Americas_Reseller_Program_TandC_UE.pdf';

export const ATTACH_MAX_SIZE = 5000000;
export const MSG_ATTACH_MAX_SIZE_ERROR = "This file exceeds the maximum size limit of 5MB.";